import {Cidades} from '../Modelos/Cidades';

export class Enderecos
{
    id_end: number = 0;
    logr_end: string = '';
    cep_end: string = '';
    bairro_end: string = '';
    cidade: Cidades = new Cidades();
}